import Header from "@/components/landing/Header";
import Footer from "@/components/landing/Footer";
import FloatingActions from "@/components/landing/FloatingActions";
import { MapPin } from "lucide-react";
import { Button } from "@/components/ui/button";
import { COMPANY } from "@/lib/company";

export default function AreasWeServePage() {
  const scrollToForm = () => { window.location.href = "/#lead-form"; };
  return (
    <div data-testid="areas-page" className="min-h-screen bg-white text-neutral-900">
      <Header onCtaClick={scrollToForm} />

      <main className="pt-32 pb-20 lg:pt-40 lg:pb-28">
        <div className="max-w-5xl mx-auto px-6 lg:px-10">
          <p className="text-[11px] uppercase tracking-[0.25em] text-[#C5A059] font-semibold mb-3">
            Coverage
          </p>
          <h1 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-light tracking-tight mb-6 leading-[1.05]" data-testid="areas-h1">
            Areas We Serve In Dubai
          </h1>
          <p className="text-base lg:text-lg text-neutral-700 leading-relaxed mb-10 max-w-3xl">
            {COMPANY.name} provides apartment renovation, villa renovation, bathroom remodeling, kitchen renovation, painting, flooring, gypsum ceiling, electrical, plumbing, and complete interior fit-out services across Dubai&apos;s premium residential and commercial communities.
          </p>

          <div className="grid grid-cols-2 sm:grid-cols-3 gap-px bg-neutral-200 border border-neutral-200">
            {COMPANY.serviceAreas.map((area) => (
              <div key={area} className="bg-white p-4 lg:p-5 flex items-center gap-2.5 hover:bg-[#F9F8F6]">
                <MapPin className="w-3.5 h-3.5 text-[#C5A059] flex-shrink-0" />
                <span className="text-sm text-neutral-800">{area}, Dubai</span>
              </div>
            ))}
          </div>

          <div className="mt-10 text-center">
            <a href="/#lead-form">
              <Button className="bg-[#C5A059] hover:bg-[#A88746] text-white rounded-none px-7 py-6 font-medium">
                Request a Bespoke Consultation
              </Button>
            </a>
          </div>
        </div>
      </main>

      <Footer />
      <FloatingActions />
    </div>
  );
}
